import React from 'react'
import PropTypes from 'prop-types'
import { Logo } from './Logo'

function Placeholder() {
  return (
    <div className="code-placeholder">
      <div style={{ width: '40%' }} />
      <div style={{ width: '25%' }} />
      <div style={{ width: '0', height: '0.5ch' }} />
      <div style={{ width: '35%' }} />
      <div style={{ width: '0', height: '0.5ch' }} />
      <div style={{ width: '30%' }} />
      <div style={{ width: '60%' }} />
      <div style={{ width: '20%', marginLeft: '6%' }} />
      <div style={{ width: '15%', marginLeft: '6%' }} />
      <div style={{ width: '25%', marginLeft: '12%' }} />
      <div style={{ width: '15%', marginLeft: '6%' }} />
      <div style={{ width: '10%' }} />
      <div style={{ width: '0%', height: '0.5ch' }} />
      <div style={{ width: '25%' }} />
      <span className="placeholder-logo">
        <Logo style={{ width: '4rem', marginTop: '-0.6rem' }} />
        <span className="placeholder-logo-text">COMING SOON</span>
      </span>
    </div>
  )
}

export function Code({ type, children }) {
  return <div className={`${type}-code`}>{children ?? <Placeholder />}</div>
}

Code.propTypes = {
  type: PropTypes.oneOf(['frontend', 'canister']).isRequired,
  children: PropTypes.node,
}
